import React from "react"

const CurrencyComponent = ({ currency, amount }) => {
  return (
    <div>
      {currency?.symbol} {amount}
    </div>
  )
}

export default CurrencyComponent
